var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('RenderTable',{ref:"d_table",staticClass:"table-base d_table",staticStyle:{"width":"100%","margin-top":"0"},attrs:{"size":"small","height":"400px","data":_vm.tableData,"columns":_vm.columns}})}
var staticRenderFns = []

export { render, staticRenderFns }